export default "__VITE_ASSET__61408500__"